(function($){
    $(document).ready(function(){

        $('.homeSlide').slick({
          slidesToShow: 1,
          slidesToSlide: 1,
          speed: 2000,
          dots: false,
          arrows: false,
          //autoplay: true,
          //autoplaySpeed: 6000
        });

        $('.gallerySlider').slick({
          slidesToShow: 1,
          slidesToSlide: 1,
          speed: 2000,
          dots: false,
          arrows: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                dots: true,
                arrows: false
              }
            },
          ]
        });

        $('.testSlider').slick({
          slidesToShow: 1,
          slidesToSlide: 1,
          speed: 2000,
          dots: false,
          arrows: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                dots: true,
                arrows: false
              }
            },
          ]
        });

        $(".togbut").click(function(){
            $(".bars").toggle();
            $(".cross").toggle();
        });

        var stickyNavTop = $('.stickWrap').offset().top;

        var stickyNav = function(){
            var scrollTop = $(window).scrollTop(); // our current vertical position from the top
        		if (scrollTop > stickyNavTop) {
        		    $('.stickWrap').addClass('sticky');
        		} else {
        			  $('.stickWrap').removeClass('sticky');
        		}
         };

        stickyNav();
        // and run it again every time you scroll
        $(window).scroll(function() {
            stickyNav();
        });

    });
})(jQuery);
